export default {
    common: {
        datepicker: {
            months: {
                july: 'Juillet',
                september: 'Septembre',
                april: 'Avril',
                march: 'Mars',
                may: 'Mai',
                february: 'Février',
                june: 'Juin',
                january: 'Janvier',
                november: 'Novembre',
                october: 'Octobre',
                august: 'Août',
                december: 'Décembre',
            },
            days: {
                tuesday: 'Ma',
                thursday: 'Je',
                saturday: 'Sa',
                wednesday: 'Me',
                monday: 'Lu',
                friday: 'Ve',
                sunday: 'Di',
            },
        },
        label: {
            insured: 'Assuré',
            selected: 'Sélectionné',
            noValue: 'Aucune information disponible',
            cancel: 'Annuler',
            bestseller: 'Best-seller',
            moreDetails: 'Détails',
            next: 'Suivant',
            no: 'Non',
            ok: 'Ok',
            choose: 'Sélectionner',
            to: 'de',
            notInsured: 'Non assuré',
            back: 'Retour',
            save: 'Enregistrer',
            edit: 'Modifier',
            yes: 'Oui',
        },
        unsavedData: {
            message: 'Vous avez des données non enregistrées sur cette page. Voulez-vous vraiment recharger cette page?',
        },
        technicalError: {
            actionText: 'Nouvelle tentative',
            message: 'En raison d\'une erreur technique, votre demande n\'a pas pu être traitée. Veuillez réessayer plus tard.',
        },
        invalidForm: {
            message: 'Vos données saisies sont incomplètes ou non valides. Veuillez vérifier vos données saisies et réessayer.',
        },
    },
    summaryStep: {
        insurance: {
            title: 'Couverture d’assurance choisie',
            subtitle: 'Prestations incluses (vous trouverez des informations détaillées et des explications dans l’aperçu des prestations) ',
        },
        share: {
            label: 'Transmettre par e-mail',
            heading: 'Transmettre, traiter plus tard ou imprimer',
            send: {
                label: 'Envoyer',
            },
            subtitle: 'Vous pouvez envoyer ce résumé par e-mail. Vos données saisies restent enregistrées et peuvent être complétées ou modifiées ultérieurement. De plus, il est également possible d’imprimer le résumé.',
            toast: {
                success: 'L’e-mail contenant le lien a été envoyé avec succès.',
                failed: 'L’e-mail n’a malheureusement pas pu être envoyé!',
            },
        },
        contact: {
            phone: {
                label: 'Téléphone',
            },
            mail: {
                label: 'E-mail de confirmation',
            },
            title: 'Coordonnées du preneur d’assurance',
        },
        construction: {
            title: 'Projet de construction',
            sum: {
                label: 'Total',
            },
            duration: {
                label: 'Durée de construction',
            },
        },
        title: 'Résumé',
        advisor: {
            title: 'Données de l’intermédiaire',
            mail: {
                label: 'E-Mail de l\'intermédiaire',
            },
        },
        risks: {
            title: 'Caractéristiques',
        },
        print: {
            title: 'Assurance construction',
            label: 'Imprimer le résumé',
        },
        submit: {
            hint: 'La couverture d\'assurance commence à partir de la date de début de votre construction saisie en ligne.',
            label: 'Acheter maintenant',
        },
        edit: {
            toast: {
                message: 'Votre prime a été recalculée!',
            },
        },
        avb: {
            label: '<ul style="list-style: disc;"> <li> Je confirme avoir lu les <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/fr/vertragsbedingungen/156_1009_2_f.pdf"  target="_blank">informations sur le produit</a> et l’<a href="https://www.baloise.ch/fr/notre-societe/informations/protection-des-donnees.html" target="_blank">information sur la protection des données concernant les contrats d’assurance,</a> j’accepte les  <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/fr/vertragsbedingungen/156_1009_2_f.pdf" target="_blank">conditions contractuelles générales </a>et j’autorise Baloise à <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Procuration-pour-obtenir-des-informations-de-tiers.pdf" target="_blank">demander des   renseignements de tiers.</a> </li> <li>Je confirme avoir répondu à toutes les questions conformément à la vérité.</li> </ul>',
            label_fl: '<ul style="list-style: disc;"> <li> Je confirme avoir lu les <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/fr/vertragsbedingungen/156_1009_2_f.pdf"  target="_blank">informations sur le produit</a> et l’<a href="https://www.baloise.ch/fr/notre-societe/informations/protection-des-donnees.html" target="_blank">information sur la protection des données concernant les contrats d’assurance,</a> j’accepte les  <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/fr/vertragsbedingungen/156_1009_2_f.pdf" target="_blank">conditions contractuelles générales </a>et j’autorise Baloise à <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Procuration-pour-obtenir-des-informations-de-tiers.pdf" target="_blank">demander des  renseignements de tiers.</a> </li> <li>Je confirme avoir répondu à toutes les questions conformément à la vérité.</li> <li>Je libère Baloise du <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Secret-commercial-liechtensteinois.pdf" target="_blank">secret commercial liechtensteinois.</a></li> <li>J’accepte les <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/cyber/000_1362_f.pdf" target="_blank">dispositions supplémentaires pour les contrats selon le droit  liechtensteinois</a> et je confirme avoir pris connaissance du <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/IPID/156_1025_d.pdf" target="_blank">document d’information  sur le produit d’assurance (IPID).</a> </li> </ul>',
        },
        dp: {
            text: 'En soumettant vos données, vous donnez votre consentement au traitement de votre demande. Vous avez le droit de révoquer ce consentement à tout moment. Vous trouverez plus d’informations sur nos traitements de données dans notre <a href="https://www.baloise.ch/fr/notre-societe/informations/protection-des-donnees.html" target="_blank">information sur la protection des données</a>.',
        },
    },
    matrixStep: {
        liability: {
            visitor: {
                label: 'Assurance-accidents visiteurs',
            },
            personAndPropertyDamage: {
                label: 'Prestation maximale (garantie unique pour toute la durée du contrat)',
            },
            label: 'Responsabilité civile du maître d’ouvrage',
            doubleGuaranty: {
                label: 'Double garantie (la somme assurée est disponible deux fois)',
            },
            legalProtectionAndFinancialLosses: {
                label: 'Les dommages économiques purs et la protection juridique lors de procédures pénales, par couverture',
            },
        },
        construction: {
            earthquake: {
                label: 'Tremblements de terre et éruptions volcaniques',
            },
            base: {
                tooltip: 'La couverture de base couvre les dommages matériels imprévus survenant au bâtiment en cours de construction pendant la durée de la construction. Vol d’objets qui sont montés ou fixés à l’ouvrage.',
                label: 'Couverture de base',
            },
            addition: {
                one: {
                    label: 'Les choses mobiles, les frais d’experts et de recherche de dommages, les dommages dus à des dégâts d’eau, par couverture',
                },
                label: 'Couverture complémentaire',
                two: {
                    label: 'Les rayures sur les vitrages, les frais supplémentaires liés au travail supplémentaire et au fret aérien, les retards dans la construction et l’interruption du chantier, par couverture',
                },
                tooltip: 'La couverture complémentaire couvre, entre autres choses, les échafaudages, étayages, la fouille et le sol, les bâtiments existants, le mobilier, les outils, les engins, machines de construction et équipements.',
                three: {
                    label: 'Vol avec effraction de choses non fixées à l’ouvrage',
                },
            },
            label: 'Travaux de construction',
        },
        quote: {
            label: 'Prime unique en CHF',
            stampDuty: {
                label: 'Y compris droit de timbre',
            },
        },
        details: {
            link: 'https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/fr/factsheets/Informations-produit_Assurance-construction.pdf',
            label: 'Ce tableau n’est qu’un résumé. Vous trouverez tous les détails et explications utiles dans <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/fr/factsheets/Informations-produit_Assurance-construction.pdf" target="_blank">l’aperçu des prestations</a>.',
        },
        deductible: {
            hint: 'pour les travaux de construction et la responsabilité civile du maître d’ouvrage',
            label: 'Franchise',
        },
        additionalLimit: {
            hint: 'pour les travaux de construction et la responsabilité civile du maître d’ouvrage',
            label: 'Double garantie',
            singleGuarantee: '-',
            doubleGuarantee: 'Assuré',
        },
        title: 'Sélectionnez la couverture d’assurance optimale',
    },
    typeStep: {
        constructionType: {
            apartmentHouse: {
                label: 'Immeuble d’habitation',
            },
            altLink: {
                text: 'Si vous ne trouvez pas le type de bâtiment souhaité,',
                alt: 'poursuivez ici.',
                url: 'https://www.baloise.ch/fr/clients-entreprises/assurer/responsabilite-civile-droit-biens-materiels/construction/assurance-construction/demande-d-offre-assurance-construction-1.html',
            },
            industrialBuilding: {
                label: 'Bâtiment à usage commercial',
            },
            commerceAndLiving: {
                label: 'Bâtiment d’habitation et commerces',
            },
            detachedHouse: {
                label: 'Maison individuelle',
            },
            title: 'Veuillez sélectionner votre type de bâtiment',
            validation: {
                message: 'Veuillez sélectionner votre type de construction.',
            },
        },
        constructionKind: {
            renovation: {
                tooltip: 'En cas de remise en état d’un bâtiment sans modification de la structure porteuse (démolition d’un mur porteur, p. ex.) ou intervention sur la toiture, veuillez sélectionner Rénovation.',
                label: 'Transformation/rénovation',
            },
            newBuilding: {
                tooltip: 'Si le projet porte sur une nouvelle construction, un agrandissement d’un bâtiment existant ou une transformation, veuillez sélectionner Nouvelle construction/agrandissement/transformation.',
                label: 'Nouvelle construction/agrandissement',
            },
            title: 'Veuillez sélectionner votre projet de construction',
        },
    },
    riskStep: {
        supportStructureChanged: {
            tooltip: 'Si vous répondez non, nous partons du principe qu’il s’agit d’une rénovation.',
            label: 'Des éléments porteurs (p.ex. murs, plafonds, balcons) sont-ils modifiés ou le toit fait-il l’objet de travaux?',
        },
        underpinning: {
            tooltip: 'Reprise en sous-oeuvre ou recoupage inférieur d’éléments de construction ou d’ouvrages de tiers (p.ex. Bâtiments, murs de soutènement, canalisations, installations ferroviaires)',
            label: 'Des reprises en sous-oeuvre et/ou recoupages inférieurs de parties de bâtiments/d’ouvrages de tiers sont exécutés?',
        },
        groundwater: {
            label: 'Le niveau de la nappe phréatique sera-t-il abaissé?',
            tooltip: 'Abaissement du niveau des eaux souterraines à l’intérieur de l’enceinte de fouille ou à l’extérieur de la fouille (un assèchement de la fouille n’est pas considéré comme un abaissement du niveau des eaux souterraines)',
        },
        dangerZone: {
            warning: 'Comme votre projet de construction se situe dans une zone de dangers, nous ne pouvons malheureusement pas calculer la prime en ligne. Nous nous ferons néanmoins un plaisir de vous soumettre une offre. N’hésitez pas à nous <a target="_blank" href="https://www.baloise.ch/fr/clients-entreprises/assurer/responsabilite-civile-droit-biens-materiels/construction/assurance-construction/demande-d-offre-assurance-construction-1.html"> contacter</a>.',
            label: 'Le projet de construction se trouve-t-il dans une zone de dangers avec un risque moyen ou élévé de crues, de glissements de terrain, d’éboulements de rochers, de chutes de pierres, d’avalanches ou y a-t-il un risque de ruissellement de surface (hauteur d\'eau ≥25 cm) ?',
            tooltip: 'Les cartes des dangers des cantons, de la Principauté de Liechtenstein, de l\'Association des établissements cantonaux d\'assurance (AECA) et de l\'Association Suisse d\'Assurances (ASA) sont déterminantes pour l\'évaluation. Si les dangers dans l\'expertise géologique ont été évaluées différemment, ce sont ces évaluations qui sont déterminantes.',
        },
        ram: {
            label: 'Des pieux, palplanches ou profilés métalliques sont battus, foncés ou vibrés dans le sol?',
        },
        rock: {
            label: 'Des travaux de déroctage (destruction de rochers par minage, à l’aide de marteaux-piqueurs ou de brise-roches) sont exécutés?',
        },
        newConstruction: {
            label: 'Un nouveau bâtiment ou un agrandissement est-il construit?',
        },
        title: 'Quelques questions sur votre projet de construction',
    },
    success: {
        title: 'Merci!',
        lead: 'Nous avons bien reçu vos données.<br>Vous recevrez sous peu vos documents contractuels.<br>Avez-vous des questions? N’hésitez pas à nous contacter au <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
    },
    contactStep: {
        birthdate : {
            label: 'Date de naissance',
        },
        street: {
            validation: {
                message: 'Veuillez saisir une rue valide.',
            },
            placeholder: 'Rue et numéro de maison',
        },
        title: 'Vous y êtes presque!',
        lastName: {
            placeholder: 'Nom',
            validation: {
                message: 'Veuillez saisir un nom valide.',
            },
        },
        languageOfCorrespondence: {
            de: 'Allemand',
            label: 'Langue de correspondance',
            fr: 'Français',
            it: 'Italien',
        },
        postcode: {
            placeholder: 'NPA',
            validation: {
                message: 'Veuillez saisir un code postal valide.',
            },
        },
        city: {
            validation: {
                message: 'Veuillez saisir une localité valide.',
            },
            placeholder: 'Localité',
        },
        firstName: {
            placeholder: 'Prénom',
            validation: {
                message: 'Veuillez saisir un prénom valide.',
            },
        },
        subtitle: {
            email: 'À qui la confirmation peut-elle être envoyée?',
            contact: 'Coordonnées du preneur d’assurance',
        },
        salutation: {
            validation: {
                message: 'Veuillez sélectionner le titre de civilité.',
            },
            female: 'Madame',
            male: 'Monsieur',
            company: 'Entreprise',
        },
        phone: {
            validation: {
                message: 'Veuillez saisir un numéro de téléphone valide.',
            },
            placeholder: 'Téléphone',
        },
        advisor: {
            placeholder: 'Si un intermédiaire vous a proposé l’assurance, veuillez indiquer ici son nom et son numéro d’intermédiaire (p. ex. architecte, courtier, etc.)',
            label: 'Données de l’intermédiaire (en option)',
            contactStep: {},
        },
        advisorMail: {
            placeholder: 'E-Mail de l\'intermédiaire (en option)',
        },
        email: {
            placeholder: 'E-Mail du preneur d\'assurance',
            validation: {
                message: 'Veuillez saisir une adresse e-mail valide.',
            },
        },
        companyName: {
            placeholder: 'Entreprise',
            validation: {
                message: 'Veuillez saisir une raison sociale valide.',
            },
        },
        next: 'Voir le résumé',
    },
    whenStep: {
        startDate: {
            title: 'Quand commencez-vous à construire?',
            validation: {
                message: 'Veuillez sélectionner une date valide.',
            },
            tooltip: 'La couverture d\'assurance commence au plus tôt avec la conclusion du contrat.',
            placeholder: 'Début des travaux',
        },
        completionDate: {
            validation: {
                message: 'Veuillez sélectionner la période.',
            },
            title: 'Jusqu’à quand construisez-vous?',
            year: 'an',
            placeholder: 'Fin des travaux',
            upTo: 'Jusqu’à',
            tooltip: 'Si votre projet de construction dure plus de 3ans, <a target="_blank" href="https://www.baloise.ch/fr/clients-entreprises/assurer/responsabilite-civile-droit-biens-materiels/construction/assurance-construction/demande-d-offre-assurance-construction-1.html"> poursuivez ici.</a>',
            years: 'ans',
        },
        title: 'Durée de construction',
    },
    whereStep: {
        postcode: {
            placeholder: 'NPA',
            label: '',
            validation: {
                message: 'Veuillez saisir un code postal valide.',
            },
        },
        street: {
            label: '',
            validation: {
                message: 'Veuillez saisir une adresse valide.',
            },
            placeholder: 'Rue et numéro de maison ou numéro de parcelle',
        },
        city: {
            validation: {
                message: 'Veuillez saisir une localité valide.',
            },
            placeholder: 'Localité',
            dropDownLabel: 'Veuillez choisir',
            label: '',
        },
        title: 'Où construisez-vous?',
    },
    fail: {
        lead: 'Veuillez réessayer plus tard ou contactez-nous au <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        title: 'Une erreur est malheureusement survenue.',
    },
    sumStep: {
        sum: {
            info: {
                text1: 'Pour calculer le coût de construction, additionnez les positions 1 à 4 du Code des frais de construction (y compris la taxe sur la valeur ajoutée, les honoraires et propres prestations du maître d’ouvrage).',
                text2: 'N’entrent pas en ligne de compte dans les frais de construction les coûts pour les études préliminaires, les concours, l’acquisition et l’aménagement du terrain, le financement et les taxes.',
                text3: 'Si votre coût de construction est supérieure à CHF 10\'000\'000, <a target="_blank" href="https://www.baloise.ch/fr/clients-entreprises/assurer/responsabilite-civile-droit-biens-materiels/construction/assurance-construction/demande-d-offre-assurance-construction-1.html"> poursuivez ici.</a>',
                title: 'Comment calculer le coût de construction?',
            },
            label: 'CHF',
            placeholder: '500\'000',
            validation: {
                message: 'Le coût de construction doit être compris entre CHF CHF 10\'000 et CHF 10 millions maximum.',
            },
        },
        title: 'Quel est le coût de construction?',
    },
    app: {
        title: 'Baloise assurance construction',
    },
    overview: {
        print: {
            label: 'Imprimer l’offre',
        },
        hint: {
            text: 'Avez-vous des questions? N’hésitez pas à nous contacter à l’adresse mail suivante: <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        },
        title: 'Votre offre en détail',
    },
    easteregg: {
        message: 'Un heureux produit du Bets-Team',
    },
};
